import { Component, inject, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { MaintenanceOrderEnums } from 'src/app/enum/maintenance-order-enum';
import { MaintenanceOrderModel } from 'src/app/models/maintenance/maintenance-order.model';
import { MaintenanceOrderActivitiesTableModel } from 'src/app/models/tables/maintenance/maintenance-order-activities-table.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { MaintenanceOrderActivitiesService } from 'src/app/services/maintenance/maintenance-order-activities.service';
import { MaintenanceOrderService } from 'src/app/services/maintenance/maintenance-order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-maintenance-order-activities',
  templateUrl: './maintenance-order-activities.component.html',
  styleUrls: ['./maintenance-order-activities.component.scss'],
  standalone: false
})
export class MaintenanceOrderActivitiesComponent implements OnInit {

  public config = inject(DynamicDialogConfig);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly maintenanceOrderActivitiesService = inject(MaintenanceOrderActivitiesService);
  private readonly maintenanceOrderService = inject(MaintenanceOrderService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  @Optional() private ref = inject(DynamicDialogRef);

  disableCheckbox: boolean = false;
  maintenanceOrderModel: MaintenanceOrderModel = new MaintenanceOrderModel();
  maintenanceOrderActivities: MaintenanceOrderActivitiesTableModel[] = [];
  permissionUpdatable: boolean = false;
  haveMaintenanceOrigin: boolean = false;
  suscription: Subscription;

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe(async (inputs: any) => {
      this.maintenanceOrderModel = inputs.maintenanceOrderModel;
      this.permissionUpdatable = inputs.permissionUpdatable;
    });
    await this.validateMaintenanceOrderOrigin();
    if (this.maintenanceOrderModel.maintenanceOrderStateId == MaintenanceOrderEnums.abierta && this.permissionUpdatable && !this.haveMaintenanceOrigin) {
      this.disableCheckbox = false;
    } else {
      this.disableCheckbox = true;
    }

    await Promise.all([
      this.getMaintenanceOrderActivities()
    ])

  }

  async addActivities() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para agregar actividades de la orden de mtto.
            Comuníquese con el administrador del sistema.`);
      return;
    }

    if (!this.maintenanceOrderModel.maintenancePlan) {
      this.toastHandlerService.showToast('error', `La orden de mtto no tiene un plan de mtto.`);
      return;
    }

    try {
      await firstValueFrom(this.maintenanceOrderActivitiesService.createActivitiesByMaintenancePlanAsync(this.maintenanceOrderModel.maintenanceOrderId, this.maintenanceOrderModel.articleId, this.maintenanceOrderModel.maintenancePlan));
      await this.getMaintenanceOrderActivities();
      this.onReloadEmit();
      this.toastHandlerService.showToast('success', 'Las actividades fueron agregadas exitosamente.');
    } catch (error) {
      console.error('Error al agregar las actividades.', error);
    }
  }

  async changeCheckBox(activity: MaintenanceOrderActivitiesTableModel, field: 'swExecuted' | 'swRescheduled') {
    try {
      if (field === 'swExecuted') {
        activity.swRescheduled = !activity.swExecuted;
      } else if (field === 'swRescheduled') {
        activity.swExecuted = !activity.swRescheduled;
      }

      await firstValueFrom(this.maintenanceOrderActivitiesService.updateMaintenanceOrderActivities(activity.maintenanceOrderActivitiesId, activity.swExecuted, activity.swRescheduled));
    } catch (error) {
      console.error('Error al actualizar la actividad.', error);
    }
  }

  async deleteAllActivities() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar actividades de la orden de mtto.
            Comuníquese con el administrador del sistema.`);
      return;
    }

    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar todas las actividades de la orden de mtto?');
    if (accepted) {
      try {
        await firstValueFrom(this.maintenanceOrderActivitiesService.deleteAllMaintenanceOrderActivitiesAsync(this.maintenanceOrderModel.maintenanceOrderId));
        await this.getMaintenanceOrderActivities();
        this.onReloadEmit();
        this.toastHandlerService.showToast('success', 'Todas las actividades fueron eliminadas exitosamente.');
      } catch (error) {
        console.error('Error al eliminar las actividades.', error);
      }
    }
  }

  async getMaintenanceOrderActivities() {
    try {
      this.maintenanceOrderActivities = await firstValueFrom(this.maintenanceOrderActivitiesService.getMaintenanceOrderActivities(this.maintenanceOrderModel.maintenanceOrderId));
    } catch (error) {
      console.error('Error al obtener lo elementos por id.', error);
    }
  }

  onReloadEmit() {
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'onReload', payload: true });
  }

  async validateMaintenanceOrderOrigin() {
    try {
      this.haveMaintenanceOrigin = await firstValueFrom(this.maintenanceOrderService.validateMaintenanceOrderOrigin(this.maintenanceOrderModel.maintenanceOrderId));
    } catch (error) {
      console.error('Error al validar el kmHoromValue', error);
    }
  }

}
